module.exports = __webpack_public_path__ + "static/media/file9.0a43949d.jpg";